/* Click-only, independent card galleries; no hover, timer or scroll-driven swaps. */
if (!customElements.get('med-card-gallery')) {
  customElements.define('med-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-photo-images]');
      if (!data) return;
      try { this.photos = JSON.parse(data.textContent); } catch (_) { return; }
      this.image = this.querySelector('.med-catalog-photo');
      this.previous = this.querySelector('[data-photo-previous]');
      this.next = this.querySelector('[data-photo-next]');
      this.status = this.querySelector('[data-photo-status]');
      if (!this.image || !this.previous || !this.next || this.photos.length < 2) return;
      this.ready = true; this.index = 0; this.request = 0;
      this.originalSrcset = this.image.getAttribute('srcset');
      this.originalSrc = this.image.getAttribute('src');
      this.previous.hidden = this.next.hidden = false;
      this.previous.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.show(this.index - 1); });
      this.next.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.show(this.index + 1); });
    }
    show(index) {
      if (index < 0 || index >= this.photos.length) return;
      const token = ++this.request, photo = this.photos[index], loaded = new Image();
      loaded.onload = () => {
        if (token !== this.request || !this.isConnected) return;
        this.image.removeAttribute('srcset');
        this.image.src = index === 0 ? this.originalSrc : photo.src;
        if (index === 0 && this.originalSrcset) this.image.setAttribute('srcset', this.originalSrcset);
        this.image.alt = photo.alt; this.index = index;
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.photos.length - 1;
        this.status.textContent = `Photo ${index + 1} of ${this.photos.length}`;
      };
      loaded.onerror = () => { if (token === this.request) this.status.textContent = 'This photo could not load. Please try again.'; };
      loaded.src = photo.src;
    }
  });
}
